function addSimilarTitle({ userId, metadataId, similarMetadataId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/similartitles`;
  return apiClient.post(route, { userId, metadataId, similarMetadataId });
}

function removeSimilarTitle({ userId, similarMetadataId }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/similartitles/${similarMetadataId}`;
  return apiClient.delete(route, { userId });
}

export default {
  addSimilarTitle,
  removeSimilarTitle
};
